import { isValidDate } from "@/utils";
// 校验批次号
export const validateBatch = async (rules, value) => {
  if (!value) return Promise.reject("请输入正确的生产批号");
  // 校验位数
  if (value && value.length !== 10)
    return Promise.reject("请输入正确的生产批号");
  // 校验年月日
  const y = value.slice(3, 5);
  const m = value.slice(5, 7);
  const d = value.slice(7, 9);
  const ymd = `20${y}-${m}-${d}`;
  if (!isValidDate(ymd)) {
    return Promise.reject(`日期${y}-${m}-${d}有误,请输入正确的日期`);
  }

  const regExpBacth = new RegExp(/^BCP2[3-9]\d{4}[A|B|C|D|E|F|G|H|I|J]$/);
  if (regExpBacth.test(value)) {
    return Promise.resolve();
  }

  return Promise.reject("请输入正确的生产批号");
};

// 校验批次号
export const validateFQCBatch = async (rules, value) => {
  if (!value) return Promise.reject("请输入正确的生产批号");
  // 校验位数
  if (value && value.length !== 6)
    return Promise.reject("请输入正确的生产批号");
  const regExpBacth = new RegExp(/^SC[K|A|B|C|D|E|F|G|H|I]{4}$/);
  if (regExpBacth.test(value)) {
    return Promise.resolve();
  }

  return Promise.reject("请输入正确的生产批号");
};
